import React from 'react';
import { FileText } from 'lucide-react';

const DokumentyModul = () => {
  return (
    <div className="space-y-6">
      {/* Content */}
      <div className="bg-white shadow rounded-lg p-8">
        <div className="text-center py-12">
          <FileText className="h-16 w-16 text-gray-400 mx-auto mb-4" />
          <h2 className="text-xl font-semibold text-gray-900 mb-2">
            Moduł Dokumenty
          </h2>
          <p className="text-gray-500">
            Moduł jest w przygotowaniu. Wkrótce będzie możliwość dodawania i zarządzania dokumentami.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DokumentyModul;

